export default __webpack_public_path__ + "static/avatar-kortical-team1-225a5d911d8c1249782b951bc82283fe.jpg";